// extracted by mini-css-extract-plugin
export var danger = "stackedProgressBar-module--danger--fc1bb";
export var info = "stackedProgressBar-module--info--0da43";
export var other = "stackedProgressBar-module--other--8c6c7";
export var success = "stackedProgressBar-module--success--0fc60";
export var warning = "stackedProgressBar-module--warning--6e9c5";
export var wrapper = "stackedProgressBar-module--wrapper--3e4b4";